import { useNavigate } from 'react-router-dom';

function Poc(props) {
    function PopUpPocImage() {  
        window.open('/event/poc-image', '_blank');
    }
    function PopUpPocImage2() {
        window.open('/event/poc-image2', '_blank');
    }
    const navigate = useNavigate();

    return (
        <div>
            
            <button onClick={() => navigate('/event/poc-image')}>PocImage</button>
            <button onClick={() => navigate('/event/poc-image2')}>PocImage2</button>
            <button onClick={() => PopUpPocImage()}>PocImage</button>
            <button onClick={() => PopUpPocImage2()}>PocImage2</button>
        </div>
    );
}

export default Poc;